<!-- Owner Onboarding Checklist - Only visible to Owner and Chief Supervisor -->
<div class="card" *ngIf="(isOwnerOrChiefSupervisor$ | async) && !(onboardingDismissed$ | async) && !(onboardingCompleted$ | async)">
  <div class="card-body p-3">
    <!-- Header with Title and Progress -->
    <div class="checklist-header d-flex justify-content-between align-items-center mb-4">
      <h5 class="checklist-title mb-0">Getting Started</h5>

      <div class="progress-section d-flex align-items-center gap-3">
        <div class="progress flex-grow-1 h-6px">
          <div
            class="progress-bar"
            role="progressbar"
            [style.width.%]="completionPercentage$ | async"
            [attr.aria-valuenow]="completionPercentage$ | async"
            aria-valuemin="0"
            aria-valuemax="100">
          </div>
        </div>
        <div class="progress-text">
          <span class="small text-muted" *ngIf="completedCount$ | async as count">
            {{ count.completed }}/{{ count.total }} Completed
          </span>
        </div>
      </div>
    </div>

    <!-- Checklist Items -->
    <div class="checklist-items d-flex flex-column gap-3">
      <div
        *ngFor="let item of checklist$ | async"
        class="checklist-item d-flex align-items-center gap-3 p-3 px-4 rounded-3 border"
        [class.completed]="item.isCompleted"
        [class.clickable]="!item.isCompleted && item.actionRoute"
        (click)="navigateToItem(item)"
        role="button"
        [attr.tabindex]="!item.isCompleted && item.actionRoute ? 0 : -1">

        <!-- Checkbox Icon -->
        <div class="checklist-icon-wrapper flex-shrink-0">
          <div class="checklist-icon" [class.checked]="item.isCompleted">
            <i class="bi" [ngClass]="item.isCompleted ? 'bi-check-circle' : 'bi-circle'"></i>
          </div>
        </div>

        <!-- Item Content -->
        <div class="checklist-content flex-grow-1 min-w-0">
          <h6 class="checklist-item-title mb-1">
            {{ item.title }}
            <span *ngIf="!item.isRequired" class="badge ms-2">Optional</span>
          </h6>
          <p class="checklist-item-description mb-0">{{ item.description }}</p>
        </div>

        <!-- Arrow Icon -->
        <div class="checklist-arrow flex-shrink-0" *ngIf="!item.isCompleted && item.actionRoute">
          <i class="bi bi-arrow-right"></i>
        </div>
      </div>
    </div>

    <!-- Dismiss Button -->
    <div class="mt-3">
      <button
        type="button"
        class="btn btn-sm btn-primary"
        (click)="dismissChecklist()">
        Dismiss
      </button>
    </div>
  </div>
</div>

<!-- Completed State - Show welcome message once per session -->
<div class="alert alert-success d-flex align-items-center shadow-sm" role="alert" *ngIf="showWelcomeMessage$ | async">
  <i class="bi bi-check-circle-fill me-3 fs-4"></i>
  <div>
    <h6 class="alert-heading mb-1">Welcome to American Drone Network!</h6>
    <p class="mb-0 small">Your account is fully set up and ready to go.</p>
  </div>
</div>
